import { Dialog } from '@mui/material';
import { RetailerNetworkLocationFilter } from '@occc/graphql';
import { LoadingOverlay } from '@occc-app/design-system';
import { RetailerNetworkLocationsTableContainer } from './retailer-network-locations-table/retailer-network-locations-table.container';

type RetailerNetworkLocationGroupAddLocationsDialogProps = {
  open: boolean;
  setOpen: (open: boolean) => void;
  filter: Omit<RetailerNetworkLocationFilter, 'search'>;
  onAddLocationsToLocationGroup: (locationUuids: string[]) => Promise<void>;
  loading?: boolean;
  retailerNetworkLocationGroupUuid: string;
};

export const RetailerNetworkLocationGroupAddLocationsDialog = ({
  open,
  setOpen,
  filter,
  onAddLocationsToLocationGroup,
  loading,
  retailerNetworkLocationGroupUuid,
}: RetailerNetworkLocationGroupAddLocationsDialogProps) => {
  const onClose = () => setOpen(false);

  return (
    <Dialog onClose={onClose} open={open} fullWidth maxWidth='md'>
      {loading && <LoadingOverlay />}
      <RetailerNetworkLocationsTableContainer
        title='Choose Locations to Add to Location Group'
        filter={filter}
        handleBulkAction={onAddLocationsToLocationGroup}
        retailerNetworkLocationGroupUuid={retailerNetworkLocationGroupUuid}
      />
    </Dialog>
  );
};
